/* External */
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

/* Components */
import LiveContent from './liveContent/LiveContent';
import SeriesDetails from '../components/seriesDetails/SeriesDetails';
import VodContent from './vodContent/VodContent';
import { useGtmContext } from '../components/GtmContext';

/* Styles */
import './Pdp.scss';

/* Other */
import { history } from '../state/configureStore';
import { PATHS, PDP_ASSET_TYPES } from '../utils';

function Pdp({
  match: {
    params: { assetId, assetType },
  },
}) {
  const consecutivePdpCount = useSelector((state) => state.navigation.consecutivePdpCount);
  const containerRef = useRef();
  const {
    setGtmContent,
    setGtmPlaySource,
    setGtmSectionName,
    setGtmComponentType,
    setGtmCarouselVerticalPosition,
  } = useGtmContext();

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, []);

  useEffect(() => {
    containerRef.current.scroll(0, 0);
  }, [assetId]);

  const handleClose = () => {
    setGtmContent(null);
    setGtmPlaySource(null);
    setGtmSectionName(null);
    setGtmComponentType(null);
    setGtmCarouselVerticalPosition(null);
    return consecutivePdpCount ? history.go(-consecutivePdpCount) : history.replace(PATHS.HOME);
  };

  const getContent = () => {
    switch (assetType) {
      case PDP_ASSET_TYPES.live:
        return <LiveContent channelId={assetId} resourceType={assetType} />;
      case PDP_ASSET_TYPES.series:
        return <SeriesDetails assetId={assetId} onErrorAction={handleClose} />;
      case PDP_ASSET_TYPES.movies:
      case PDP_ASSET_TYPES.vod:
        return <VodContent assetId={assetId} />;
      default:
        return null;
    }
  };

  const content = getContent();

  return (
    <div className="dtv-details" ref={containerRef}>
      <div className="dtv-details-icons">
        <span onClick={handleClose} className="dtv-details-icons-icon dtv-icon-close" />
      </div>
      <div className="dtv-details-content">{content}</div>
    </div>
  );
}

Pdp.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default Pdp;
